import Vue from 'vue';
import i18n from '@/plugins/i18n';
Vue.mixin({
    methods: {
        getErrorMessage(errors: Array<string>) {
            const error: string = errors[0];
            if (!error) return error;
            // if string template is 'abc|xyz|I18n'
            if (error.includes('I18n')) {
                const arr = error.split('|');
                const [message, ...fieldParams] = arr;
                const params: Record<string, unknown> = {};
                fieldParams.forEach((f) => {
                    const key = f.split(':')[0];
                    const value = f.split(':')[1] ? f.split(':')[1].trim() : '';
                    params[key] = (value || '').includes('.') ? i18n.t(value) : value;
                });
                return i18n.t(message, params);
            }
            return error;
        },
    },
});
